import RadioGroup from './RadioGroup';

// export types
export type { RadioGroupProps } from './RadioGroup';

// export components
export { RadioGroup };
export default RadioGroup;
